import { render, staticRenderFns } from "./billedVsRealInteractive.vue?vue&type=template&id=7ab7a3a8&scoped=true"
import script from "./billedVsRealInteractive.vue?vue&type=script&lang=js"
export * from "./billedVsRealInteractive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab7a3a8",
  null
  
)

export default component.exports